import React, { useState } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import apiUrl from "../Apiurl";
import ModificaProdottiNEW from "../modificaProdotti/ModificaProdottiNEW";
import AreaConflittoCodiciPS from "../AreaConflittoCodiciPS";
import DBperAreaProblemiPS from "./AreaProblemiPSComponenti/DBperAreaProblemiPS";

function AreaProblemiPS({product,setProductFunction,utente,tradPermessa, charCount, listaNomiProdotto}) {

    

    /////// PROPS ///////////////

    //const utente = props.utente
    const {
        /* buttonClassesWhite,
        buttonClassesRed,
        buttonClassesOrange,
        buttonClassesGreen,
        inputClasses,
        inputClassesThird, */
        inputClassesConTasto/*,
         inputClassesConDueTasti,
        inputClassesConTreTasti,
        spazioTestoConTasto,
        classiTastoBlocco,
        classiTastoSblocco,
        classiTastoCopiaInAlto,
        classiTastoSbloccoVerde,
        tastoQuadratoVerde,
        tastoQuadratoGiallo,
        tastoQuadratoRosso,
        tastoQuadratoBianco,
        buttonClassesWhiteNoBorder */
    } = stilePulsanti

    /////// HOOKS ///////////////

    const [idPSdiverso, setIDPSdiverso] = useState({
        idPSdiversoTrovato: "",
        idAttuale: ""
      });



    return (
        <div className='center'>
            <div className='cf'>
                {/* <h1>scegli prod o crea nuovo: [input show or create]</h1> */}
                <div className="fl w-100 w-100-ns">
                {product.codiceVS === "NO DATA" && 
                !idPSdiverso.idPSdiversoTrovato &&
                <div className="sfondoBiancoTema">
                        <DBperAreaProblemiPS
                            product={product}
                            setProductFunction={setProductFunction}
                            utente={utente}
                            tradPermessa={tradPermessa}
                            setIDPSdiverso={setIDPSdiverso}
                        />                        
                    </div>}
                    
                </div>
                <div className="fl w-100 w-100-ns">
                { 
                idPSdiverso.idPSdiversoTrovato &&
                <div className="sfondoBiancoTema">
                        <AreaConflittoCodiciPS
                            prodDB={product}
                            idPSesistente={idPSdiverso.idPSdiversoTrovato}
                            idPSnuovo={idPSdiverso.idAttuale}
                            setProductFunction={setProductFunction}
                            utente={utente}
                            setIDPSdiverso={setIDPSdiverso}
                        />                        
                    </div>}
                    
                </div>
                <div className="fl w-100 w-100-ns">
                    <div className="sfondoBiancoTema">
                    
                    {product.codiceVS !== "NO DATA" && 
                    !idPSdiverso.idPSdiversoTrovato &&
                    <ModificaProdottiNEW
                        prodotto={product}
                        setProductFunction={setProductFunction}
                        utente={utente}
                        listaNomiProdotto={listaNomiProdotto}
                        /* listaNomiProdotto={listaNomiProdotto} */
                        />}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AreaProblemiPS;